// 본문에 표시되지 못하고 첨부파일로 구제된 인라인 파트인지 판별한다. (비정상 데이터)
// - cid/contentId가 있지만 본문에서 참조되지 않는 이미지. (inline 분류에서 탈락한 파일에
//   대해 호출되므로, cid가 있다는 것은 곧 본문 미참조를 의미한다.)
// - htmlBody/textBody 배열에 interleave되어 있었지만 본문으로 렌더되지 않은 파트. (Apple Mail 등)
//
// 구제된 파트는 정상 첨부파일 뒤에 표시한다.

interface RescuedCheckBodyPart {
  htmlPartIds?: string[] | null
  textPartIds?: string[] | null
}

interface RescuedCheckFile {
  partId?: string | null
  cid?: string | null
  contentId?: string | null
}

export const isRescuedInlineAttachment = (
  bodyPart: RescuedCheckBodyPart,
  file: RescuedCheckFile,
): boolean => {
  if (file.cid != null || file.contentId != null) {
    return true
  }
  if (file.partId == null) {
    return false
  }
  const { htmlPartIds, textPartIds } = bodyPart
  if (htmlPartIds != null && htmlPartIds.includes(file.partId) === true) {
    return true
  }
  if (textPartIds != null && textPartIds.includes(file.partId) === true) {
    return true
  }
  return false
}
